import React from 'react';
import { Spin } from 'antd';
import moment from 'moment';
import Modal from '../publicComponents/modal';
import { connect } from 'react-redux';
import { getAllEvents } from '../actions/actions';
import DateFormatter from '../publicComponents/formatDate';

class EventContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isContentLoading: true,
      eventCount: 0,
      imageURL: '',
      title: '',
      visible: false,
    };
  }

  componentDidMount = () => {
    this._ismounted = true;
    this.props.getAllEvents().then(() => {
      const { eventList } = this.props;
      this.setState({
        eventCount: eventList.length,
        isContentLoading: false,
      });
    });
  };

  handleClick = (eventURL, name, e) => {
    this.setState({
      imageURL: eventURL,
      title: name,
      visible: true,
    });
  };

  setModalStatus = status => {
    this.setState({
      visible: status,
    });
  };

  componentWillUnmount() {
    this._ismounted = false;
  }

  render() {
    const {
      isContentLoading,
      eventCount,
      imageURL = '',
      title = '',
      visible = '',
    } = this.state;
    const { eventList } = this.props;
    return (
      <Spin tip='Loading' spinning={isContentLoading}>
        {imageURL && (
          <Modal
            getModalStatus={this.setModalStatus}
            title={title}
            visible={visible}
            imageURL={imageURL}
          />
        )}
        <article className='article-padd-half bg-gray'>
          <div className='container'>
            <div className='row'>
              <div className='col-md-12'>
                <div className='pg-hd'>
                  <h3>Events ({eventCount})</h3>
                </div>
              </div>
              {eventCount > 0 &&
                eventList.map(key => {
                  return (
                    <div className='col-md-6' key={key.id}>
                      <div className='event-wrap'>
                        <h4>
                          <DateFormatter date={key.date} />
                        </h4>
                        <div className='event-img'>
                          <a href='javascript:void(0);'>
                            <img
                              width={200}
                              alt=''
                              className='img-fluid'
                              src={key.eventURL}
                              onClick={e =>
                                this.handleClick(key.eventURL, key.name, e)
                              }
                            />
                          </a>
                        </div>

                        <div className='event-info'>
                          <h3>{key.name}</h3>
                          <p>{key.description}</p>
                          <div className='location-info'>
                            <img src='images/location-icon.png' alt='' />
                            <p>{key.address}</p>
                          </div>
                          <div className='location-info'>
                            <img src='images/clock-icon.png' alt='' />
                            <p>
                              {moment(key.startTime, 'HH:mm:ss A').format(
                                'hh:mm A'
                              )}
                            </p>
                            &nbsp; <p> to </p>&nbsp;
                            <p>
                              {' '}
                              {moment(key.endTime, 'HH:mm:ss A').format(
                                'hh:mm A'
                              )}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </article>
      </Spin>
    );
  }
}
const mapStateToProps = (state, props) => {
  const { homeData } = state;
  if (homeData)
    return {
      eventList: homeData,
    };
  return {
    eventList: null,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    getAllEvents: () => dispatch(getAllEvents()),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EventContent);
